<template>
  <div>
    <board-write-link v-for="writeLayout in writeLayouts" :key="`boardComp${writeLayout}`"
                      :writeLayout="writeLayout" :boardData="boardData"></board-write-link>
  </div>
</template>

<script>
import BoardWriteLink from "@/components/board/BoardWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardValidator from "@/mixins/validators/boardValidator";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import DeleteClass from "@/mixins/deleteClass";

export default {
  name: "BoardWriteComponent",
  mixins: [alertMixins, boardTemplateUtil, boardFilterUtil, boardValidator],
  components: {BoardWriteLink},
  inject: ['changeLoading'],
  provide() {
    return {
      boardWriteSetData: this.setData,
    }
  },
  props: {
    boardType: {},
    boardKey: {default: 0},
  },
  data() {
    return {
      writeLayouts: [],
      writeFunc: '',
      writeApiParamSet: {},
      parsingData: {},
      directUrl: '',
      directType: '',
      keyName: '',
      writeSuccessType: 1,
      writeFailTypes: {},
      fileType: '',
      getFunc: '',
      detailApiParamsSet: {},
      getKeyName: 'id',
      boardData: {},
      date: '',
      be_end: 0,
      bc_idx:'',

      deleteFunc: '',
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      deleteErrorTypes: [],
      DeleteClass: null,
      isRunning:false,
    }
  },
  created() {
    this.initFilterConfig();
    this.newDeleteClass();
    if (this.boardKey === 0) {
      this.initTemplateConfig();
    } else {
      this.getBoard();
    }
  },
  mounted() {
    EventBus.$on('writeBoard', this.runWriteConfirm);
    EventBus.$on('writeCommentBoard', this.runCommentConfirm);
    EventBus.$on('runDeleteConfirm', this.runDeleteConfirm);
    EventBus.$on('runNoticeWriteConfirm', this.runNoticeWriteConfirm);
    EventBus.$on('runNoticeUpdateConfirm', this.runNoticeUpdateConfirm);

  },
  beforeDestroy() {
    EventBus.$off('writeBoard');
    EventBus.$off('writeCommentBoard');
    EventBus.$off('runDeleteConfirm');
    EventBus.$off('runNoticeWriteConfirm');
    EventBus.$off('runNoticeUpdateConfirm');

  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(key, value) {
      this[key] = value;
    },
    initTemplateConfig() {
      let configBoard = this.returnBoardTemplateConfig(this.boardType);
      this.writeLayouts = configBoard.writeLayouts;
    },
    initFilterConfig() {
      let configBoard = this.returnBoardFilterConfig(this.boardType);
      this.writeFunc = configBoard.writeFunc;
      this.writeApiParamSet = configBoard.writeApiParamSet;
      this.parsingData = configBoard.parsingData;
      this.getFunc = configBoard.getFunc;
      this.detailApiParamsSet = configBoard.detailApiParamsSet;
      this.getKeyName = configBoard.getKeyName;
      this.directUrl = configBoard.directUrl;
      this.directType = configBoard.directType;
      this.keyName = configBoard.keyName;
      this.fileType = configBoard.fileType;
      this.writeSuccessType = configBoard.writeSuccessType;
      this.writeFailTypes = configBoard.writeFailTypes;

      this.deleteFunc = configBoard.deleteFunc;
      this.deleteApiParamsSet = configBoard.deleteApiParamsSet;
      this.deleteSuccessType = configBoard.deleteSuccessType;
      this.deleteFailTypes = configBoard.deleteFailTypes;
      this.keyName = configBoard.keyName;
    },

    getBoard() {
      let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
      !util.isEmpty(this.getKeyName) ? params[this.getKeyName] = this.boardKey : params.id = this.boardKey;
      this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
        if (res.Info.type != 1 || res.List.length === 0) {
          this.createAlert({
            title: '',
            content: '데이터를 불러올 수 없습니다.',
            btnText: '확인',
            hide: () => {
              this.$router.back();
            }
          });
          return;
        }
        this.boardData = res.List[0];
        this.initTemplateConfig();
      })
    },
    runWriteConfirm() {
      this.createConfirm({
        content: '작성한 게시물이 바로 저장됩니다<br>저장하시겠습니까?',
        confirm: () => {
          this.writeBoard();
        }
      })
    },
    runNoticeWriteConfirm() {
      this.createConfirm({
        content: '작성한 공지사항이 바로 저장됩니다<br>저장하시겠습니까?',
        confirm: () => {
          this.writeBoard();
        }
      })
    },
    runNoticeUpdateConfirm() {
      this.createConfirm({
        content: '작성한 공지사항이 바로 수정됩니다<br>수정하시겠습니까?',
        confirm: () => {
          this.writeBoard();
        }
      })
    },
    runCommentConfirm() {
      this.createConfirm({
        content: '작성한 답변이 바로 전송됩니다<br>전송하시겠습니까?',
        confirm: () => {
          this.writeBoard();
        }
      })
    },
    writeBoard() {
      if (this.isRunning) {
        return false;
      }
      this.isRunning = true;
      let dataArr = Object.keys(this.parsingData);
      console.log(dataArr)
      this.$validate(dataArr).then(success => {
        if (!success) {
          util.Array.each(this.writeLayouts, (layout, index, arr) => {
            EventBus.$emit(`${layout}Validator`, dataArr);
          });
          this.errorAlert('필수정보를 모두 입력해 주세요.');
          this.isRunning = false;
          return;
        }
        this.changeLoading(true);
        let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
        dataArr = Object.keys(this.parsingData);
        dataArr.forEach(dataKey => {
          params[this.parsingData[dataKey]] = this[dataKey];
        })

        if (this.boardKey != 0 && util.isEmpty(params.wr_parent) && this.boardType != 'qnaUpdate') {
          params.wr_id = this.boardKey;
        }
        if (this.boardType === 'qnaUpdate') {
          params.wr_parent = this.boardKey;
          if (util.isEmpty(this.boardData.Comment.List)) {
            this.writeFunc = 'updateQnaComment';
          } else {
            params.wr_id = this.boardData.Comment.List[0].wr_id;
            this.writeFunc = 'updateQna';
          }
        }else{
          params.c_idx = this.language;
        }
        console.log(params)
        try {
          this.$api.$board[this.writeFunc](params).then(res => res.Data.Result).then(res => {
            let type = this.returnBoardType(res.Info.type);
            if (type != true) {
              this.changeLoading(false);
              this.isRunning = false;
              this.errorAlert(type);
              return false;
            } else {
              this.afterFunc(this.boardKey);
            }
          });

        } catch (e) {
          this.changeLoading(false);
          console.log(e);
        }
      })
    },
    returnBoardType(type) {
      if (type == this.writeSuccessType) {
        return true;
      } else {
        return util.isEmpty(this.writeFailTypes[type]) ? '실패입니다.' : this.writeFailTypes[type]
      }
    },
    afterFunc(key) {
      this.changeLoading(false);
      this.isRunning = false;
      let detailKey = key;
      this.createAlert({
        title: '',
        content: '저장되었습니다.',
        btnText: '확인',
        hide: () => {
          if (this.directType === 'back') {
            this.$router.back();
            return false;
          }
          if (this.directUrl === '') {
            this.writeLayouts = [];
            this.deleteFiles = [];
            this.getBoard();
            return false;
          }
          let url = this.directUrl;
          if (this.directType === 'detail') {
            url = url + detailKey;
          }
          this.$router.push(url);
        }
      })
    },
    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$board[this.deleteFunc],
        apiParamSet: this.deleteApiParamsSet,
        keyName: this.keyName,
        errorTypes: this.deleteFailTypes,
        successType: this.deleteSuccessType,
        afterFunc: this.deleteAfterFunc,
      }
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    runDeleteConfirm() {
      this.createConfirm({
        content: '삭제시 다시 복구 할 수 없습니다.<br>정말 삭제 하시겠습니까?',
        confirm: () => {
          this.runDelete();
        }
      })
    },
    runDelete() {
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.boardKey);
    },
    deleteAfterFunc() {
      this.changeLoading(false);
      this.createAlert({
        content: '삭제되었습니다.',
        hide: () => {
          this.$router.back();
        }
      })
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
